<template>
  <div class="container">
    <h1>Statistic by CostLimit Period</h1>
    <div class="row margin-bottom-2">
      <div class="col-xs-4">
        <DevAppDropDownComponent role="sms" @devapp-changed="devAppChanged"/>
      </div>
    </div>
    <sdx-loading-spinner v-if="isLoading" size="large" sr-hint="Loading. Please wait."/>
    <div v-if="!isLoading && costLimitQuotas.length === 0" class="alert alert-info">
      This statistic is only available if a cost limit is defined.<br>
      <a :href="'/cost/limit'" class="link">Go to configuration</a>
    </div>
    <div v-if="showGraph">
      <canvas id="costLimitChart"></canvas>
    </div>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import statisticsCostLimitService from '../service';
import DevAppDropDownComponent from '@/components/DevAppDropDownComponent';

Chart.register(...registerables);

export default {
  components: { DevAppDropDownComponent },
  data() {
    return {
      chart: null,
      showGraph: false,
      isLoading: false,
      costLimitQuotas: [],
      limitNational: null,
      limitInternational: null,
      webId: undefined,
    };
  },
  methods: {
    async loadCostLimitQuotas() {
      this.isLoading = true;
      try {
        const response = await statisticsCostLimitService.getCostLimitQuotasByWebId(this.webId);
        // Neue Struktur: limits und quotas
        this.limitNational = response.data.limitNational;
        this.limitInternational = response.data.limitInternational;
        this.costLimitQuotas = response.data.quotas;
        this.showGraph = this.costLimitQuotas.length > 0;
        await this.$nextTick();
        this.renderChart();
      } catch (error) {
        this.showGraph = false;
      } finally {
        this.isLoading = false;
      }
    },
    renderChart() {
      if (this.chart) {
        this.chart.destroy();
      }
      const ctx = document.getElementById('costLimitChart');
      const labels = this.costLimitQuotas.map(q => q.periode);
      const dataNational = this.costLimitQuotas.map(q => q.costsNational);
      const dataInternational = this.costLimitQuotas.map(q => q.costsInternational);
      // Linien für die Limits
      const lineNational = labels.map(() => this.limitNational);
      const lineInternational = labels.map(() => this.limitInternational);
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'National',
              data: dataNational,
              backgroundColor: '#30AAE3', //light blue
              type: 'bar',
            },
            {
              label: 'International',
              data: dataInternational,
              backgroundColor: '#0055A4', //dark blue
              type: 'bar',
            },
            {
              label: `Limit National (${this.limitNational})`,
              data: lineNational,
              borderColor: '#FF6F61', // light red
              backgroundColor: 'transparent',
              type: 'line',
              borderWidth: 2,
              pointRadius: 0,
              fill: false,
            },
            {
              label: `Limit International (${this.limitInternational})`,
              data: lineInternational,
              borderColor: '#B22222', // dark red
              backgroundColor: 'transparent',
              type: 'line',
              borderWidth: 2,
              pointRadius: 0,
              fill: false,
            }
          ],
        },
        options: {
          responsive: true,
          plugins: {
            title: { display: true, text: 'Cost by period' },
          },
        },
      });
    },
    async devAppChanged(webId) {
      this.webId = webId;
      await this.loadCostLimitQuotas();
    },
  },
};
</script>

<style scoped>
.container { margin-top: 20px; }
</style>
